module.exports = __webpack_public_path__ + "img/round-arrow-right.f572595e.svg";